import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import { InputStatus } from '../../../__legacy__/models/error.model';

export interface IRenameAttachmentStore {
  readonly showModal: boolean;
  readonly nameStatus: InputStatus;
  readonly name: string;
  readonly id: string;
  readonly parentId?: string;
  initialize(attachmentId: string, attachmentName: string, parentId: string | undefined): void;
  setShowModal(showModal: boolean): void;
  setNameStatus(nameStatus: InputStatus): void;
  setName(name: string): void;
}

export namespace IRenameAttachmentStore {
  export const $: interfaces.ServiceIdentifier<IRenameAttachmentStore> = Symbol('RENAME_ATTACHMENT_STORE');
}

@injectable()
export class RenameAttachmentStore implements IRenameAttachmentStore {
  showModal: boolean = false;

  nameStatus: InputStatus = InputStatus.empty();

  name: string = '';

  id: string = '';

  parentId: string | undefined = undefined;

  constructor() {
    makeObservable(this, {
      showModal: observable,
      nameStatus: observable,
      name: observable,
      id: observable,
      parentId: observable,
      initialize: action,
    });
  }

  initialize(attachmentId: string, attachmentName: string, parentId: string | undefined): void {
    this.showModal = false;
    this.nameStatus = InputStatus.empty();
    this.id = attachmentId;
    this.name = attachmentName;
    this.parentId = parentId;
  }

  setShowModal(showModal: boolean): void {
    this.showModal = showModal;
  }

  setNameStatus(nameStatus: InputStatus): void {
    this.nameStatus = nameStatus;
  }

  setName(name: string): void {
    this.name = name;
  }
}
